<script setup lang="ts">
defineEmits<{ close: [] }>()

const {
  $lcServicesSearch: { searchPresenter },
} = useNuxtApp()

const inquiry = computed(() => ({
  adults: searchPresenter.vm.updatedInquiry?.numberOfAdults ?? 0,
  babies: searchPresenter.vm.updatedInquiry?.numberOfBabies ?? 0,
  children: searchPresenter.vm.updatedInquiry?.numberOfChildren ?? 0,
  comment: searchPresenter.vm.updatedInquiry?.clientComment ?? '',
}))
</script>

<template>
  <div
    class="mb-4 flex w-full flex-col gap-6 sm:grid sm:grid-cols-2 sm:gap-x-12"
  >
    <div
      class="flex w-full flex-col gap-5 bg-secondary-100 p-4 text-md sm:bg-white sm:px-0"
    >
      <div class="summary__section">
        <p class="font-bold">
          {{ $t('inquiry.summary.groupComposition.title') }}
        </p>
        <div class="summary__group">
          <p>
            {{ $t('inquiry.summary.groupComposition.adults', inquiry.adults) }}
          </p>
          <p class="text-base">{{ inquiry.adults }}</p>
        </div>
        <div class="summary__group">
          <p>
            {{
              $t('inquiry.summary.groupComposition.children', inquiry.children)
            }}
          </p>
          <p class="text-base">{{ inquiry.children }}</p>
        </div>
        <div class="summary__group">
          <p>
            {{ $t('inquiry.summary.groupComposition.babies', inquiry.babies) }}
          </p>
          <p class="text-base">{{ inquiry.babies }}</p>
        </div>
      </div>
    </div>

    <div>
      <InquiryFeedbackBanner
        class="summary__feedback"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<style scoped>
p,
h3 {
  @apply m-0;
}
.summary__section {
  @apply flex w-full flex-col gap-2;
}
.summary__group {
  @apply flex w-full items-center justify-between border-b border-b-gray-200 py-2 last:border-none;
}
.summary__feedback :deep(> h4) {
  @apply font-bold !text-base;
}
.summary__feedback :deep(> div) {
  @apply !text-md !mb-4;
}
.summary__feedback :deep(> a) {
  @apply !text-md;
}
</style>
